export const data = [
    {
        id: "157725830",
        streetAddress: "6565 E Thomas Rd UNIT 1101",
        zipcode: "85251",
        city: "Scottsdale",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/e0ebcd74d4af313e95981550c92c0e67-p_e.jpg",
        price: 490000,
        bathrooms: 2,
        bedrooms: 2,
        homeType: "CONDO",
        homeStatus: "FOR_SALE",
        priceInText: "$490,000",
        area: 1161,
        statusText: "Condo for sale",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "7581571",
        streetAddress: "8263 E Cypress St",
        zipcode: "85257",
        city: "Scottsdale",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/b2803cda4e34f6ff1604f0a1cc5ced4e-p_e.jpg",
        price: 760000,
        bathrooms: 2,
        bedrooms: 4,
        homeType: "SINGLE_FAMILY",
        homeStatus: "FOR_SALE",
        priceInText: "$760,000",
        area: 1626,
        statusText: "House for sale",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "7859313",
        streetAddress: "7307 E Manzanita Dr",
        zipcode: "85258",
        city: "Mesa",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/4f3ed241b8ff2486d2aa63415799f8a0-p_e.jpg",
        price: 750000,
        bathrooms: 2,
        bedrooms: 3,
        homeType: "HOUSE",
        homeStatus: "FOR_SALE",
        priceInText: "$750,000",
        area: 2091,
        statusText: "House for sale",
        openHouseStartDate: "2022-11-17T12:00:00",
    },
    {
        id: "2066312469",
        streetAddress: "7870 E Camelback Rd UNIT 411",
        zipcode: "85251",
        city: "Goodyear",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/76de002c37e9f296f5ad8b70dd2a6643-p_e.jpg",
        price: 425000,
        bathrooms: 2,
        bedrooms: 2,
        homeType: "CONDO",
        homeStatus: "FOR_SALE",
        priceInText: "$425,000",
        area: 1560,
        statusText: "Condo for sale",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "8052637",
        streetAddress: "13554 E Sorrel Ln",
        zipcode: "85259",
        city: "Glendale",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/4420943d75d80058d9ef3d2b6176297c-p_e.jpg",
        price: 1500000,
        bathrooms: 5,
        bedrooms: 5,
        homeType: "SINGLE_FAMILY",
        homeStatus: "FOR_SALE",
        priceInText: "$1,500,000",
        area: 4149,
        statusText: "House for sale",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "7856226",
        streetAddress: "6338 N 87th St",
        zipcode: "85250",
        city: "Surprise",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/8db643669c2dcf6301119e83549eba98-p_e.jpg",
        price: 899888,
        bathrooms: 2,
        bedrooms: 4,
        homeType: "HOUSE",
        homeStatus: "FOR_SALE",
        priceInText: "$899,888",
        area: 1970,
        statusText: "House for sale",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "7855663",
        streetAddress: "8738 E Via De Belleza",
        zipcode: "85258",
        city: "Scottsdale",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/7f9b63347e644840c97b28059de5b43a-p_e.jpg",
        price: 975000,
        bathrooms: 2,
        bedrooms: 3,
        homeType: "CONDO",
        homeStatus: "FOR_SALE",
        priceInText: "$975,000",
        area: 1832,
        statusText: "House for sale",
        openHouseStartDate: "2022-11-19T10:00:00",
    },
    {
        id: "2127359033",
        streetAddress: "8221 E Garfield St UNIT L24",
        zipcode: "85257",
        city: "Surprise",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/e8dcff94aa8db9850e435f999ab90c19-p_e.jpg",
        price: 198500,
        bathrooms: 2,
        bedrooms: 2,
        homeType: "TOWNHOUSE",
        homeStatus: "FOR_SALE",
        priceInText: "$198,500",
        area: 61031,
        statusText: "Townhouse for sale",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "7847541",
        streetAddress: "8629 E Monterosa Ave",
        zipcode: "85251",
        city: "Glendale",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/ba0aa4e50d08be9621a1ab1e5cc99d6a-p_e.jpg",
        price: 725000,
        bathrooms: 2,
        bedrooms: 3,
        homeType: "SINGLE_FAMILY",
        homeStatus: "FOR_SALE",
        priceInText: "$725,000",
        area: 1913,
        statusText: "House for sale",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "7857441",
        streetAddress: "7339 E Rovey Ave",
        zipcode: "85250",
        city: "Goodyear",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/d97f3168397be3d4586f0699a32462c4-p_e.jpg",
        price: 547500,
        bathrooms: 2,
        bedrooms: 3,
        homeType: "CONDO",
        homeStatus: "FOR_SALE",
        priceInText: "$547,500",
        area: 2468,
        statusText: "House for sale",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "7857512",
        streetAddress: "7308 E Keim Dr",
        zipcode: "85250",
        city: "Gilbert",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/beacb5df481c001ad0d45220446ca7cb-p_e.jpg",
        price: 655000,
        bathrooms: 2,
        bedrooms: 3,
        homeType: "SINGLE_FAMILY",
        homeStatus: "FOR_SALE",
        priceInText: "$655,000",
        area: 2240,
        statusText: "House for sale",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "8036238",
        streetAddress: "7487 E Visao Dr",
        zipcode: "85266",
        city: "Phoenix",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/1a05a7a57b87b2870356834b39574ad4-p_e.jpg",
        price: 1300000,
        bathrooms: 3,
        bedrooms: 3,
        homeType: "SINGLE_FAMILY",
        homeStatus: "FOR_SALE",
        priceInText: "$1,300,000",
        area: 2992,
        statusText: "House for sale",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "8057009",
        streetAddress: "13363 N 93rd Pl",
        zipcode: "85260",
        city: "Laveen",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/e314bf25376b5e3d5c7a855afff42552-p_e.jpg",
        price: 915000,
        bathrooms: 3,
        bedrooms: 4,
        homeType: "SINGLE_FAMILY",
        homeStatus: "FOR_SALE",
        priceInText: "$915,000",
        area: 2394,
        statusText: "House for sale",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "7581443",
        streetAddress: "7337 E Portland St",
        zipcode: "85257",
        city: "Phoenix",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/dc587a10bc89c2776195615547e7ea56-p_e.jpg",
        price: 699000,
        bathrooms: 2,
        bedrooms: 4,
        homeType: "CONDO",
        homeStatus: "FOR_SALE",
        priceInText: "$699,000",
        area: 1702,
        statusText: "House for sale",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "7989170",
        streetAddress: "21463 N 77th Pl",
        zipcode: "85255",
        city: "Peoria",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/da660b6a4a98b9c524437ec01e5b9da8-p_e.jpg",
        price: 1250000,
        bathrooms: 2,
        bedrooms: 3,
        homeType: "SINGLE_FAMILY",
        homeStatus: "FOR_SALE",
        priceInText: "$1,250,000",
        area: 2305,
        statusText: "House for sale",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "59264363",
        streetAddress: "27119 N 141st Pl",
        zipcode: "85262",
        city: "Avondale",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/fe0da6dff22d42e9665adce19d893924-p_e.jpg",
        price: 770000,
        bathrooms: 3,
        bedrooms: 3,
        homeType: "SINGLE_FAMILY",
        homeStatus: "FOR_SALE",
        priceInText: "$770,000",
        area: 2453,
        statusText: "House for sale",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "67766023",
        streetAddress: "27440 N Alma School Pkwy #133",
        zipcode: "85262",
        city: "Chandler",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/2d0702cd27325f14985d7bf49fdcdd9a-p_e.jpg",
        price: 250000,
        bathrooms: 3,
        bedrooms: 3,
        homeType: "TOWNHOUSE",
        homeStatus: "FOR_SALE",
        priceInText: "$250,000",
        area: 3014,
        statusText: "Townhouse for sale",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "67792216",
        streetAddress: "27811 N 156th Pl",
        zipcode: "85262",
        city: "Chandler",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/81e40c130412fbfccde19ce85d40af50-p_e.jpg",
        price: 1599900,
        bathrooms: 4,
        bedrooms: 5,
        homeType: "HOUSE",
        homeStatus: "FOR_SALE",
        priceInText: "$1,599,900",
        area: 5202,
        statusText: "House for sale",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "7859472",
        streetAddress: "7225 E Harmont Dr",
        zipcode: "85258",
        city: "Tolleson",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/f46e72d74e8b8da4afb9b501ca428190-p_e.jpg",
        price: 750000,
        bathrooms: 3,
        bedrooms: 4,
        homeType: "HOUSE",
        homeStatus: "FOR_SALE",
        priceInText: "$750,000",
        area: 2500,
        statusText: "House for sale",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "7981502",
        streetAddress: "7727 E Calle De Las Brisas",
        zipcode: "85255",
        city: "Avondale",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/69f2976f45c7ccc921300d3791aa1496-p_e.jpg",
        price: 2200000,
        bathrooms: 4,
        bedrooms: 4,
        homeType: "SINGLE_FAMILY",
        homeStatus: "FOR_SALE",
        priceInText: "$2,200,000",
        area: 3370,
        statusText: "House for sale",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "95140680",
        streetAddress: "18403 N 97th Pl",
        zipcode: "85255",
        city: "Tolleson",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/f0f189cf41b8535ed902d86158e82cfd-p_e.jpg",
        price: 2690000,
        bathrooms: 5,
        bedrooms: 5,
        homeType: "HOUSE",
        homeStatus: "FOR_SALE",
        priceInText: "$2,690,000",
        area: 4790,
        statusText: "House for sale",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "8047570",
        streetAddress: "13339 N 104th Pl",
        zipcode: "85260",
        city: "Laveen",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/fa46c6ff9e85bfe3361579f35db5204f-p_e.jpg",
        price: 650000,
        bathrooms: 2,
        bedrooms: 3,
        homeType: "TOWNHOUSE",
        homeStatus: "FOR_SALE",
        priceInText: "$650,000",
        area: 2164,
        statusText: "House for sale",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "8043212",
        streetAddress: "10294 E Jasmine Dr",
        zipcode: "85255",
        city: "Scottsdale",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/ebb41c093e22170790ad307534e916db-p_e.jpg",
        price: 1179000,
        bathrooms: 3,
        bedrooms: 4,
        homeType: "TOWNHOUSE",
        homeStatus: "FOR_SALE",
        priceInText: "$1,179,000",
        area: 2770,
        statusText: "House for sale",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "240302074",
        streetAddress: "31207 N 161st Pl",
        zipcode: "85262",
        city: "Scottsdale",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/197b7434810d5f3ef5f354ebcf786a72-p_e.jpg",
        price: 795000,
        bathrooms: 4,
        bedrooms: 4,
        homeType: "SINGLE_FAMILY",
        homeStatus: "FOR_SALE",
        priceInText: "$795,000",
        area: 3381,
        statusText: "House for sale",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "7857542",
        streetAddress: "7352 E Valley Vista Dr",
        zipcode: "85250",
        city: "Litchfield Park",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/738e71e1e11b1679859f021d3dee9c8f-p_e.jpg",
        price: 849000,
        bathrooms: 2,
        bedrooms: 3,
        homeType: "SINGLE_FAMILY",
        homeStatus: "FOR_SALE",
        priceInText: "$849,000",
        area: 2447,
        statusText: "House for sale",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "65437320",
        streetAddress: "14010 E Westland Rd",
        zipcode: "85262",
        city: "Litchfield Park",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/aebe10ab35f1877d14254cb1a2285800-p_e.jpg",
        price: 799000,
        bathrooms: 2,
        bedrooms: 4,
        homeType: "SINGLE_FAMILY",
        homeStatus: "FOR_SALE",
        priceInText: "$799,000",
        area: 2384,
        statusText: "House for sale",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "8037956",
        streetAddress: "10787 E Sutherland Way",
        zipcode: "85262",
        city: "Laveen",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/c9e1640a487c993dfc793ab13c0089a4-p_e.jpg",
        price: 1995000,
        bathrooms: 4,
        bedrooms: 3,
        homeType: "SINGLE_FAMILY",
        homeStatus: "FOR_SALE",
        priceInText: "$1,995,000",
        area: 3855,
        statusText: "House for sale",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "8050112",
        streetAddress: "10715 E Sahuaro Dr",
        zipcode: "85259",
        city: "Scottsdale",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/ac27bb6a8fae8f7c2aa9bf660151aa75-p_e.jpg",
        price: 699999,
        bathrooms: 2,
        bedrooms: 3,
        homeType: "SINGLE_FAMILY",
        homeStatus: "FOR_SALE",
        priceInText: "$699,999",
        area: 1636,
        statusText: "House for sale",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "7978375",
        streetAddress: "6038 E Long Shadow Trl",
        zipcode: "85266",
        city: "Scottsdale",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/22ed674f0647138bd70684d7219c5e38-p_e.jpg",
        price: 795000,
        bathrooms: 3,
        bedrooms: 4,
        homeType: "SINGLE_FAMILY",
        homeStatus: "FOR_SALE",
        priceInText: "$795,000",
        area: 2679,
        statusText: "House for sale",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "7579646",
        streetAddress: "7718 E Vernon Ave",
        zipcode: "85257",
        city: "Scottsdale",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/2ead3964abcaf0879980e9bb023bc816-p_e.jpg",
        price: 550000,
        bathrooms: 2,
        bedrooms: 3,
        homeType: "SINGLE_FAMILY",
        homeStatus: "FOR_SALE",
        priceInText: "$550,000",
        area: 1565,
        statusText: "House for sale",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "8054045",
        streetAddress: "9917 N 108th St",
        zipcode: "85259",
        city: "Scottsdale",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/6e58ea191326b3015eb6dbd32bb09fdf-p_e.jpg",
        price: 3500000,
        bathrooms: 5,
        bedrooms: 5,
        homeType: "SINGLE_FAMILY",
        homeStatus: "FOR_SALE",
        priceInText: "$3,500,000",
        area: 4667,
        statusText: "House for sale",
        openHouseStartDate: "2022-11-19T12:00:00",
    },
    {
        id: "7845285",
        streetAddress: "4525 N 66th St UNIT 124",
        zipcode: "85251",
        city: "Scottsdale",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/4d3f1a3295eaba76ac4fccbec072f5ed-p_e.jpg",
        price: 420000,
        bathrooms: 2,
        bedrooms: 3,
        homeType: "SINGLE_FAMILY",
        homeStatus: "FOR_SALE",
        priceInText: "$420,000",
        area: 1962,
        statusText: "House for sale",
        openHouseStartDate: "2022-11-19T12:00:00",
    },
    {
        id: "337519431",
        streetAddress: "28925 N 139th Pl",
        zipcode: "85262",
        city: "Scottsdale",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/7cc5e5060f834791b2241d1cd48a7f31-p_e.jpg",
        price: 1325900,
        bathrooms: 3,
        bedrooms: 4,
        homeType: "SINGLE_FAMILY",
        homeStatus: "FOR_SALE",
        priceInText: "$1,325,900",
        area: 3050,
        statusText: "House for sale",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "7862693",
        streetAddress: "7625 E Charter Oak Rd",
        zipcode: "85260",
        city: "Scottsdale",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/1c52a5f3742f2713ce6737853ef26e3b-p_e.jpg",
        price: 1599000,
        bathrooms: 4,
        bedrooms: 4,
        homeType: "SINGLE_FAMILY",
        homeStatus: "FOR_SALE",
        priceInText: "$1,599,000",
        area: 2537,
        statusText: "House for sale",
        openHouseStartDate: "2022-11-19T13:00:00",
    },
    {
        id: "8059553",
        streetAddress: "11333 N 92nd St UNIT 2037",
        zipcode: "85260",
        city: "Scottsdale",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/275fa4051f8b00ed483e504ee2811296-p_e.jpg",
        price: 350000,
        bathrooms: 2,
        bedrooms: 2,
        homeType: "CONDO",
        homeStatus: "FOR_SALE",
        priceInText: "$350,000",
        area: 1123,
        statusText: "Condo for sale",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "8033916",
        streetAddress: "8156 E Thorntree Dr",
        zipcode: "85266",
        city: "Scottsdale",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/f6464b8d0de26da54381b45357f247bc-p_e.jpg",
        price: 1725000,
        bathrooms: 4,
        bedrooms: 3,
        homeType: "SINGLE_FAMILY",
        homeStatus: "FOR_SALE",
        priceInText: "$1,725,000",
        area: 3976,
        statusText: "House for sale",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "8048261",
        streetAddress: "9109 E Captain Dreyfus Ave",
        zipcode: "85260",
        city: "Scottsdale",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/cf7398f6a7d0f4c969bc00ce7c1e41aa-p_e.jpg",
        price: 699900,
        bathrooms: 3,
        bedrooms: 3,
        homeType: "SINGLE_FAMILY",
        homeStatus: "FOR_SALE",
        priceInText: "$699,900",
        area: 2348,
        statusText: "House for sale",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "7981449",
        streetAddress: "23242 N 85th St",
        zipcode: "85255",
        city: "Scottsdale",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/637c0fc213d78ecc4e285d0833486418-p_e.jpg",
        price: 1500000,
        bathrooms: 2,
        bedrooms: 2,
        homeType: "TOWNHOUSE",
        homeStatus: "FOR_SALE",
        priceInText: "$1,500,000",
        area: 1807,
        statusText: "Townhouse for sale",
        openHouseStartDate: "2022-11-19T12:00:00",
    },
    {
        id: "8053071",
        streetAddress: "12244 E Palomino Rd",
        zipcode: "85259",
        city: "Scottsdale",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/bea675d5de95a8fdf9ea2ba736aa6303-p_e.jpg",
        price: 800000,
        bathrooms: 2,
        bedrooms: 3,
        homeType: "SINGLE_FAMILY",
        homeStatus: "FOR_SALE",
        priceInText: "$800,000",
        area: 2430,
        statusText: "House for sale",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "71494098",
        streetAddress: "9146 E Calle De Las Brisas",
        zipcode: "85255",
        city: "Scottsdale",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/eb3a51f27a803003816f723d546730d9-p_e.jpg",
        price: 1689900,
        bathrooms: 3,
        bedrooms: 4,
        homeType: "SINGLE_FAMILY",
        homeStatus: "FOR_SALE",
        priceInText: "$1,689,900",
        area: 3286,
        statusText: "House for sale",
        openHouseStartDate: "2022-11-13T09:00:00",
    },
    {
        id: "33.436054--111.8067",
        streetAddress: "1111 E  Brown Rd   # 250-R",
        zipcode: "85203",
        city: "Mesa",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/d918c537924cf1508fc0007d2c0466c7-p_e.jpg",
        price: 1475,
        bathrooms: 1,
        bedrooms: 1,
        homeType: "HOUSE",
        homeStatus: "FOR_RENT",
        priceInText: "$1,475+",
        area: null,
        statusText: "Copper Point",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "33.388847--111.786354",
        streetAddress: "2055 E  Hampton Ave  Apt 242",
        zipcode: "85204",
        city: "Mesa",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/52a55e3a3e21490d5f92cd63def76970-p_e.jpg",
        price: 1220,
        bathrooms: 1,
        bedrooms: 1,
        homeType: "HOUSE",
        homeStatus: "FOR_RENT",
        priceInText: "$1,220+",
        area: null,
        statusText: "The Hamptons",
        openHouseStartDate: "2022-11-18T09:00:00",
    },
    {
        id: "33.4534--112.39016",
        streetAddress: "15385 W  Fillmore St   # 202",
        zipcode: "85338",
        city: "Goodyear",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/7b132a3c311c0c0806c89a833145a555-p_e.jpg",
        price: 1525,
        bathrooms: 1,
        bedrooms: 1,
        homeType: "HOUSE",
        homeStatus: "FOR_RENT",
        priceInText: "$1,525+",
        area: null,
        statusText: "Christopher Todd Communities At Estrella Commons",
        openHouseStartDate: "2022-11-12T09:00:00",
    },
    {
        id: "33.406036--111.87954",
        streetAddress: "2145 W  Broadway Rd   Apt 136",
        zipcode: "85202",
        city: "Mesa",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/01ac09922a4b0f98daa3db0e36616ca3-p_e.jpg",
        price: 968,
        bathrooms: 0,
        bedrooms: 0,
        homeType: "HOUSE",
        homeStatus: "FOR_RENT",
        priceInText: "$968+",
        area: null,
        statusText: "Central on Broadway",
        openHouseStartDate: "2022-11-30T09:00:00",
    },
    {
        id: "33.389256--111.84362",
        streetAddress: "1362 S  Vineyard # 2026",
        zipcode: "85210",
        city: "Mesa",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/d6ac2d0ba962368675d8d751d9990f17-p_e.jpg",
        price: 1109,
        bathrooms: 0,
        bedrooms: 0,
        homeType: "HOUSE",
        homeStatus: "FOR_RENT",
        priceInText: "$1,109+",
        area: null,
        statusText: "Shorebird",
        openHouseStartDate: "2022-11-14T09:00:00",
    },
    {
        id: "33.649612--112.36921",
        streetAddress: "14155 W  Mountain View Blvd # 1050",
        zipcode: "85374",
        city: "Surprise",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/364e13e411a90417723e74b3e043e3a6-p_e.jpg",
        price: 1410,
        bathrooms: 1,
        bedrooms: 1,
        homeType: "HOUSE",
        homeStatus: "FOR_RENT",
        priceInText: "$1,410+",
        area: null,
        statusText: "Christopher Todd Communities on Mountain View",
        openHouseStartDate: "2022-11-18T09:00:00",
    },
    {
        id: "33.438004--111.81914",
        streetAddress: "1233 N  Mesa Dr   Apt 2202",
        zipcode: "85201",
        city: "Mesa",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/74853dc178eb8587488a6c8aebae677c-p_e.jpg",
        price: 1555,
        bathrooms: 2,
        bedrooms: 2,
        homeType: "HOUSE",
        homeStatus: "FOR_RENT",
        priceInText: "$1,555+",
        area: null,
        statusText: "Glen at Mesa",
        openHouseStartDate: "2022-11-15T09:00:00",
    },
    {
        id: "33.624985--112.1803",
        streetAddress: "15301 N  57th Ave  # 3018",
        zipcode: "85306",
        city: "Glendale",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/eb00c9726a2b6582c5a0a63bd58ec3ad-p_e.jpg",
        price: 1600,
        bathrooms: 1,
        bedrooms: 1,
        homeType: "TOWNHOUSE",
        homeStatus: "FOR_RENT",
        priceInText: "$1,600+",
        area: null,
        statusText: "Hangar at Thunderbird",
        openHouseStartDate: "2022-11-18T09:00:00",
    },
    {
        id: "33.44808--112.39014",
        streetAddress: "15390 W  Centerra Dr   N  # 156",
        zipcode: "85338",
        city: "Goodyear",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/c61dffb08d97ba3b83df7603af81ea39-p_e.jpg",
        price: 1514,
        bathrooms: 1,
        bedrooms: 1,
        homeType: "CONDO",
        homeStatus: "FOR_RENT",
        priceInText: "$1,514+",
        area: null,
        statusText: "Avilla Centerra Crossings",
        openHouseStartDate: "2022-11-27T09:00:00",
    },
    {
        id: "33.51443--112.27443",
        streetAddress: "9999 W  Missouri Ave  Unit 109",
        zipcode: "85305",
        city: "Glendale",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/0796cc6d44174e00ff6911a97f1b2e55-p_e.jpg",
        price: 1306,
        bathrooms: 1,
        bedrooms: 1,
        homeType: "HOUSE",
        homeStatus: "FOR_RENT",
        priceInText: "$1,306+",
        area: null,
        statusText: "Christopher Todd Communities at Stadium",
        openHouseStartDate: "2022-11-29T09:00:00",
    },
    {
        id: "33.396973--111.866234",
        streetAddress: "922 S  Longmore # 8235",
        zipcode: "85202",
        city: "Mesa",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/09c49a6b4662b1dcf1ffd4be72d3d8db-p_e.jpg",
        price: 1288,
        bathrooms: 1,
        bedrooms: 1,
        homeType: "HOUSE",
        homeStatus: "FOR_RENT",
        priceInText: "$1,288+",
        area: null,
        statusText: "Vista Valley",
        openHouseStartDate: "2022-11-21T09:00:00",
    },
    {
        id: "33.30458--111.70497",
        streetAddress: "2550 S  Recker Rd   # 413",
        zipcode: "85234",
        city: "Gilbert",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/732aa332865b2aebdc33e8999f37160e-p_e.jpg",
        price: 1650,
        bathrooms: 1,
        bedrooms: 1,
        homeType: "CONDO",
        homeStatus: "FOR_RENT",
        priceInText: "$1,650+",
        area: null,
        statusText: "Alta Cooley Station",
        openHouseStartDate: "2022-11-30T09:00:00",
    },
    {
        id: "33.508793--112.32556",
        streetAddress: "12350 W  Camelback Rd   Unit 72",
        zipcode: "85340",
        city: "Litchfield Park",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/ca8f2f421da2c71187fb5a385c45b5e9-p_e.jpg",
        price: 1809,
        bathrooms: 2,
        bedrooms: 2,
        homeType: "SINGLE_FAMILY",
        homeStatus: "FOR_RENT",
        priceInText: "$1,809+",
        area: null,
        statusText: "Christopher Todd Communities On Camelback",
        openHouseStartDate: "2022-11-26T09:00:00",
    },
    {
        id: "33.464397--112.0013",
        streetAddress: "3777 E  McDowell Rd   Apt 2065",
        zipcode: "85008",
        city: "Phoenix",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/1b90c5c927ac66b8364cfab29909b20d-p_e.jpg",
        price: 1375,
        bathrooms: 1,
        bedrooms: 1,
        homeType: "HOUSE",
        homeStatus: "FOR_RENT",
        priceInText: "$1,375+",
        area: null,
        statusText: "Oxford Apartments",
        openHouseStartDate: "2022-11-23T09:00:00",
    },
    {
        id: "33.27362--111.87801",
        streetAddress: "2222 S  Dobson Rd   # 2040",
        zipcode: "85286",
        city: "Chandler",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/a8372e01a32347ebf77d0028f51c39cb-p_e.jpg",
        price: 1445,
        bathrooms: 1,
        bedrooms: 1,
        homeType: "HOUSE",
        homeStatus: "FOR_RENT",
        priceInText: "$1,445+",
        area: null,
        statusText: "Dobson 2222",
        openHouseStartDate: "2022-11-14T09:00:00",
    },
    {
        id: "33.46625--112.28449",
        streetAddress: "10350 W  McDowell Rd   # 3162",
        zipcode: "85392",
        city: "Avondale",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/a451e162ce52ac19afa9cd60b7939458-p_e.jpg",
        price: 1480,
        bathrooms: 1,
        bedrooms: 1,
        homeType: "HOUSE",
        homeStatus: "FOR_RENT",
        priceInText: "$1,480+",
        area: null,
        statusText: "Aventura",
        openHouseStartDate: "2022-11-17T09:00:00",
    },
    {
        id: "33.552353--112.16592",
        streetAddress: "4949 W  Northern Ave  # 166",
        zipcode: "85301",
        city: "Glendale",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/239dcf14966c3d3d00f3ae61bd13dbaa-p_e.jpg",
        price: 1085,
        bathrooms: 0,
        bedrooms: 0,
        homeType: "HOUSE",
        homeStatus: "FOR_RENT",
        priceInText: "$1,085+",
        area: null,
        statusText: "Glen Brae",
        openHouseStartDate: "2022-11-13T09:00:00",
    },
    {
        id: "33.482544--112.20161",
        streetAddress: "3045 N  67th Ave  Apt 2004",
        zipcode: "85033",
        city: "Phoenix",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/7a7da751c2ee928ad56adba918018f18-p_e.jpg",
        price: 1055,
        bathrooms: 1,
        bedrooms: 1,
        homeType: "HOUSE",
        homeStatus: "FOR_RENT",
        priceInText: "$1,055+",
        area: null,
        statusText: "Villa de Cortez",
        openHouseStartDate: "2022-11-12T09:00:00",
    },
    {
        id: "33.5336--112.15656",
        streetAddress: "4530 W  McLellan Rd   # 66",
        zipcode: "85301",
        city: "Glendale",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/942973a40869d6b8171d6dce1fbe2fa7-p_e.jpg",
        price: 1675,
        bathrooms: 2,
        bedrooms: 2,
        homeType: "SINGLE_FAMILY",
        homeStatus: "FOR_RENT",
        priceInText: "$1,675+",
        area: null,
        statusText: "Maryland West Apartments",
        openHouseStartDate: "2022-11-12T09:00:00",
    },
    {
        id: "33.425243--111.79298",
        streetAddress: "1800 E  Covina St   # 198",
        zipcode: "85203",
        city: "Mesa",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/6e7bea7b32bc4f0c69f103854df2b5c8-p_e.jpg",
        price: 1275,
        bathrooms: 1,
        bedrooms: 1,
        homeType: "HOUSE",
        homeStatus: "FOR_RENT",
        priceInText: "$1,275+",
        area: null,
        statusText: "Delano Apartments",
        openHouseStartDate: "2022-11-11T09:00:00",
    },
    {
        id: "33.494377--112.38805",
        streetAddress: "4200 N  Falcon Dr   # 5",
        zipcode: "85395",
        city: "Goodyear",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/0b2a58646c0bde067d5dc9f78d3ae426-p_e.jpg",
        price: 1559,
        bathrooms: 1,
        bedrooms: 1,
        homeType: "HOUSE",
        homeStatus: "FOR_RENT",
        priceInText: "$1,559+",
        area: null,
        statusText: "Palm Valley Villas",
        openHouseStartDate: "2022-11-16T09:00:00",
    },
    {
        id: "33.424103--112.27399",
        streetAddress: "2500 S  99th Ave  Unit 9",
        zipcode: "85353",
        city: "Tolleson",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/7b3511d5515e28c7f87ebb14f381cbfd-p_e.jpg",
        price: 1547,
        bathrooms: 1,
        bedrooms: 1,
        homeType: "HOUSE",
        homeStatus: "FOR_RENT",
        priceInText: "$1,547+",
        area: null,
        statusText: "Christopher Todd Communities At Country Place",
        openHouseStartDate: "2022-11-10T09:00:00",
    },
    {
        id: "33.606285--112.3833",
        streetAddress: "15025 W  Old Oak Ln   # 1133",
        zipcode: "85379",
        city: "Surprise",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/87a9e1fa495ae50b10796116726cb394-p_e.jpg",
        price: 1444,
        bathrooms: 1,
        bedrooms: 1,
        homeType: "HOUSE",
        homeStatus: "FOR_RENT",
        priceInText: "$1,444+",
        area: null,
        statusText: "Christopher Todd Communities At Marley Park",
        openHouseStartDate: "2022-11-18T09:00:00",
    },
    {
        id: "33.650333--111.93218",
        streetAddress: "6901 E  Chauncey Ln   Apt 2195",
        zipcode: "85054",
        city: "Phoenix",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/22d3c3faf80645da6a2d113bb9731f5c-p_e.jpg",
        price: 1780,
        bathrooms: 1,
        bedrooms: 1,
        homeType: "HOUSE",
        homeStatus: "FOR_RENT",
        priceInText: "$1,780+",
        area: null,
        statusText: "Desert Club",
        openHouseStartDate: "2022-11-25T09:00:00",
    },
    {
        id: "33.608315--112.169876",
        streetAddress: "5150 W  Eugie Ave  # 1052",
        zipcode: "85304",
        city: "Glendale",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/f6cefec877cc2fb4aa57c2e116d8e7c8-p_e.jpg",
        price: 1191,
        bathrooms: 1,
        bedrooms: 1,
        homeType: "HOUSE",
        homeStatus: "FOR_RENT",
        priceInText: "$1,191+",
        area: null,
        statusText: "Aspire Thunderbird",
        openHouseStartDate: "2022-11-28T09:00:00",
    },
    {
        id: "33.322384--111.99121",
        streetAddress: "13820 S  44th St   # 1007",
        zipcode: "85044",
        city: "Phoenix",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/2a20a47943e8775f7b8d8e89b569f93a-p_e.jpg",
        price: 1757,
        bathrooms: 2,
        bedrooms: 2,
        homeType: "HOUSE",
        homeStatus: "FOR_RENT",
        priceInText: "$1,757+",
        area: null,
        statusText: "Verano Townhomes",
        openHouseStartDate: "2022-11-23T09:00:00",
    },
    {
        id: "33.66699--112.10931",
        streetAddress: "19940 N  23rd Ave  # M2133",
        zipcode: "85027",
        city: "Phoenix",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/cb18b966be4c3e8abceae2a0e32b042d-p_e.jpg",
        price: 1450,
        bathrooms: 0,
        bedrooms: 0,
        homeType: "HOUSE",
        homeStatus: "FOR_RENT",
        priceInText: "$1,450+",
        area: null,
        statusText: "Element Deer Valley",
        openHouseStartDate: "2022-11-24T09:00:00",
    },
    {
        id: "33.471783--111.98959",
        streetAddress: "2252 N  44th St   # 2125",
        zipcode: "85008",
        city: "Phoenix",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/db74b25aacd4f678b9a70fb63bda5c8e-p_e.jpg",
        price: 3330,
        bathrooms: 1,
        bedrooms: 1,
        homeType: "SINGLE_FAMILY",
        homeStatus: "FOR_RENT",
        priceInText: "$3,330+",
        area: null,
        statusText: "Arcadia Cove",
        openHouseStartDate: "2022-11-07T09:00:00",
    },
    {
        id: "33.50547--112.29149",
        streetAddress: "10770 W  Highland Ave  Unit 25",
        zipcode: "85037",
        city: "Phoenix",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/9da74e507c942f0e2b2a5c38d85c4433-p_e.jpg",
        price: 1522,
        bathrooms: 1,
        bedrooms: 1,
        homeType: "CONDO",
        homeStatus: "FOR_RENT",
        priceInText: "$1,522+",
        area: null,
        statusText: "Avilla Camelback Ranch",
        openHouseStartDate: "2022-11-29T09:00:00",
    },
    {
        id: "33.536648--112.251976",
        streetAddress: "8991 W  Glendale Ave  # 339",
        zipcode: "85305",
        city: "Glendale",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/548f600e5856e8ea5cb3a851fd6fb5ba-p_e.jpg",
        price: 2597,
        bathrooms: 1,
        bedrooms: 1,
        homeType: "HOUSE",
        homeStatus: "FOR_RENT",
        priceInText: "$2,597+",
        area: null,
        statusText: "Glen 91",
        openHouseStartDate: "2022-11-27T09:00:00",
    },
    {
        id: "33.453842--112.0819",
        streetAddress: "601 W  Fillmore St   Apt 308",
        zipcode: "85003",
        city: "Phoenix",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/173cdd294c29f48c5f96834ec6fb2287-p_e.jpg",
        price: 2609,
        bathrooms: 1,
        bedrooms: 1,
        homeType: "HOUSE",
        homeStatus: "FOR_RENT",
        priceInText: "$2,609+",
        area: null,
        statusText: "601 Pax",
        openHouseStartDate: "2022-11-20T09:00:00",
    },
    {
        id: "33.314037--111.743355",
        streetAddress: "1935 S  Santan Village Pkwy # 3064",
        zipcode: "85295",
        city: "Gilbert",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/7c5c4f2ac13200e8e35ae90d985a3a97-p_e.jpg",
        price: 1675,
        bathrooms: 0,
        bedrooms: 0,
        homeType: "HOUSE",
        homeStatus: "FOR_RENT",
        priceInText: "$1,675+",
        area: null,
        statusText: "Elevation at the Village",
        openHouseStartDate: "2022-11-24T09:00:00",
    },
    {
        id: "33.534714--112.35195",
        streetAddress: "13621 W  Glendale Ave  # 627",
        zipcode: "85307",
        city: "Glendale",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/bb06ca16ce329f802acc6a68e07a788c-p_e.jpg",
        price: 4318,
        bathrooms: 2,
        bedrooms: 2,
        homeType: "HOUSE",
        homeStatus: "FOR_RENT",
        priceInText: "$4,318+",
        area: null,
        statusText: "Maravilla",
        openHouseStartDate: "2022-12-15T09:00:00",
    },
    {
        id: "33.49614--112.07602",
        streetAddress: "4140 N  Central Ave  Apt 2105",
        zipcode: "85012",
        city: "Phoenix",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/cd6c618230bb412e6279931f77162156-p_e.jpg",
        price: 1440,
        bathrooms: 1,
        bedrooms: 1,
        homeType: "CONDO",
        homeStatus: "FOR_RENT",
        priceInText: "$1,440+",
        area: null,
        statusText: "The Station on Central",
        openHouseStartDate: "2022-11-26T09:00:00",
    },
    {
        id: "33.30409--111.864136",
        streetAddress: "1333 W  Parklane Blvd # 471",
        zipcode: "85224",
        city: "Chandler",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/fae9bb7219fc8344fadf4bc49e511ed9-p_e.jpg",
        price: 1580,
        bathrooms: 0,
        bedrooms: 0,
        homeType: "HOUSE",
        homeStatus: "FOR_RENT",
        priceInText: "$1,580+",
        area: null,
        statusText: "Alta Chandler at the Park",
        openHouseStartDate: "2022-12-26T09:00:00",
    },
    {
        id: "33.63355--112.37838",
        streetAddress: "16485 N  Stadium Way  Unit 3044",
        zipcode: "85374",
        city: "Surprise",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/9bc9fbfae9c551503b3d2ea839bd35ec-p_e.jpg",
        price: 3504,
        bathrooms: 1,
        bedrooms: 1,
        homeType: "TOWNHOUSE",
        homeStatus: "FOR_RENT",
        priceInText: "$3,504+",
        area: null,
        statusText: "The Residences at Stadium Village Apartments",
        openHouseStartDate: "2022-12-06T09:00:00",
    },
    {
        id: "33.50254--112.04862",
        streetAddress: "1550 E  Campbell Ave  # 4009",
        zipcode: "85014",
        city: "Phoenix",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/d9ac41f5b845cb70fa91069058a6fb90-p_e.jpg",
        price: 1290,
        bathrooms: 0,
        bedrooms: 0,
        homeType: "TOWNHOUSE",
        homeStatus: "FOR_RENT",
        priceInText: "$1,290+",
        area: null,
        statusText: "Level at Sixteenth",
        openHouseStartDate: "2022-11-06T09:00:00",
    },
    {
        id: "33.61498--112.238556",
        streetAddress: "14300 N  83rd Ave  Apt 3025",
        zipcode: "85381",
        city: "Peoria",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/fa2834421fb4207d0edd183b92f4d0cd-p_e.jpg",
        price: 5422,
        bathrooms: 1,
        bedrooms: 1,
        homeType: "TOWNHOUSE",
        homeStatus: "FOR_RENT",
        priceInText: "$5,422+",
        area: null,
        statusText: "Sky at P83",
        openHouseStartDate: "2022-11-09T09:00:00",
    },
    {
        id: "33.669945--112.223564",
        streetAddress: "7700 W  Aspera Blvd Apt 1102",
        zipcode: "85308",
        city: "Glendale",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/d55be92fe12e6d89e6215c1153768db8-p_e.jpg",
        price: 6713,
        bathrooms: 1,
        bedrooms: 1,
        homeType: "HOUSE",
        homeStatus: "FOR_RENT",
        priceInText: "$6,713+",
        area: null,
        statusText: "Velaire at Aspera",
        openHouseStartDate: "2022-12-16T09:00:00",
    },
    {
        id: "33.363968--112.18623",
        streetAddress: "8449 S  59th Ave  # 123",
        zipcode: "85339",
        city: "Laveen",
        state: "AZ",
        country: "USA",
        imgSrc: "https://photos.zillowstatic.com/fp/f1b39fcbcd4d3e9fe1193c1ebe4739e1-p_e.jpg",
        price: 2627,
        bathrooms: 1,
        bedrooms: 1,
        homeType: "HOUSE",
        homeStatus: "FOR_RENT",
        priceInText: "$2,627+",
        area: null,
        statusText: "Sienna at South Mountain",
        openHouseStartDate: "2022-11-26T09:00:00",
    },
];
